import { styled } from '@linaria/react';
// intl-next Link не совместим с linaria. Не критично, при необходимости стилизовать дочерений <a> вместо Link
// eslint-disable-next-line no-restricted-imports
import Link from 'next/link';

import { MqTablet } from '~theme/media';
import { coverDiv, truncateString } from '~theme/snippets';

export const Container = styled.div<{
	mini?: boolean;
	selected?: boolean;
	clean?: boolean;
}>`
	position: relative;
	display: flex;
	min-width: 0;
	flex-direction: column;
	padding: 4px;
	border: 2px solid;
	border-color: ${({ selected }) =>
		selected ? 'var(--bot-color-main)' : 'transparent'};

	border-radius: ${({ mini }) => (mini ? 'var(--radius-xs)' : '32px')};
	background-color: ${({ selected, clean }) =>
		clean
			? 'transparent'
			: selected
			? 'var(--color-black-l)'
			: 'var(--color-white-xs)'};
	box-shadow: ${({ selected }) =>
		selected ? '0px 2px 18px 0px var(--bot-color-main)' : 'none'};
	transition: background-color 0.3s, border-color 0.3s, box-shadow 0.15s;

	${MqTablet} {
		padding: 6px;
	}
`;

export const ImageWrapper = styled.div<{
	mini?: boolean;
	bordered?: boolean;
}>`
	display: flex;
	overflow: hidden;
	flex: 1;
	align-items: center;
	justify-content: center;
	border: ${({ bordered }) =>
		bordered ? '2px solid var(--color-black-solid)' : 'none'};
	border-radius: ${({ mini }) =>
		mini ? 'var(--radius-xxs)' : 'var(--radius-l)'};
	vertical-align: middle;
`;

export const Top = styled.div`
	padding: 0 15px;
	font-size: var(--font-size-5xl);
	line-height: var(--line-height-display-m);
`;

export const StyledLink = styled(Link)`
	&::after {
		content: '';
		${coverDiv}
	}
`;

export const Label = styled.label<{ unclickable?: boolean }>`
	cursor: pointer;
	pointer-events: ${({ unclickable }) => (unclickable ? 'none' : 'auto')};

	&::after {
		content: '';
		${coverDiv}
	}
`;

export const Title = styled.span<{ mini?: boolean; bottomSpace: boolean }>`
	${truncateString}

	display: block;
	padding: 12px 0 4px;
	margin-bottom: ${({ bottomSpace }) => (bottomSpace ? '12px' : '0')};
	font-size: ${({ mini }) =>
		mini ? 'var(--font-size-m)' : 'var(--font-size-l)'};
	font-weight: var(--font-weight-medium);
	text-align: center;

	${MqTablet} {
		font-size: ${({ mini }) =>
			mini ? 'var(--font-size-m)' : 'var(--font-size-xl)'};
	}
`;
